module.exports = __webpack_public_path__ + "img/logo-large.e1d0143d.png";